import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
    
    <Sides/>
    <Helmet>
 
  <title>Java loops tutorial For Beginners</title>
<meta name="description" content="Java loops tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java loops,javascript loops,java loops examples,java loop through map,java loop list,java loop through array
,java loop continue,java loop through list,leap year java,java loop through string,loop statement in java,java loops exercises" />
<link rel="canonical" href="https://www.codeexampler.com/java-looping" />
</Helmet>

<div className='lg:pl-56'>


     <h1 className="m-4 mh1">Looping Statement in Java</h1>
     <div className="first">
        <a href="/java-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">The Looping statement in java
is used to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are 3 types of looping statement in java programming:
</h2>
<h3 className="mt-4 mh3">1, Using a while looping in java statement<br/>
2, Using a do-while looping in java statement<br/>
3, Using a for looping in java <br/>

</h3>
<h2 className="mt-4 mh2">1, While loop in java:</h2>
<p className="mt-4 para">In While loop for java, a condition will be given and the body of the loop is executed until that the condition is false.
</p>


<h2 className="headings">While loop java syntax:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
            {"\n"}
      <span className="qwerty-8">while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span> 
      <span className="qwerty-1">)</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
    
      {"\n"}
      <span className="qwerty-2">&nbsp;statement</span>
          {"\n"}
      <span className="qwerty-3">&#125; </span>
    {"\n"}  {"\n"}
        
            </code>
          </pre>        
        </div>


<h2 className="mt-4 mh2">2, Do-while loop:</h2>
<p className="mt-4 para">In the do-while loop, a condition will be given and that will be checked after the execution of the body of the loop.
</p>

    
<h2 className="headings">Do while loop java syntax</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-8">do</span>
        {"\n"}
        <span className="qwerty-3">&#123; </span>

  {"\n"}
  <span className="qwerty-2">&nbsp;statement</span>
  {"\n"}
  <span className="qwerty-2">&nbsp;statement</span>
  {"\n"}
  <span className="qwerty-3">&#125; </span>
  {"\n"}
  <span className="qwerty-8">while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">condition</span> 
  <span className="qwerty-1">);</span>
  {"\n"}
 
{"\n"}
   </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">3, For loop Java:</h2>
<p className="mt-4 para">1, In the for loop java, the body of the loop will be executed until the given condition is false<br/>
2, This for loop is used to repeat a particular piece of code for a fixed no of times<br/>
3, In the for loop  java there are two semicolons must be used<br/>
</p>


<h2 className="headings">For loop Java Syntax</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
      
      {"\n"}
  <span className="qwerty-8">for</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">statement;</span>
  <span className="qwerty-4">condition;</span>
  <span className="qwerty-4">statement</span>
  <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#123; </span>
  {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;Statement ;</span>
  {"\n"}
  <span className="qwerty-3">&nbsp;&#125; </span>
  {"\n"}
  {"\n"}
        </code>
      </pre>        
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jloop;